import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { SlidersHorizontal, X } from 'lucide-react';

// Barra "filtro attivo" mostrata quando si arriva da una pre-ricerca (Home finder).
// chips: array di { icon?: LucideComponent, text: string }
export function ActiveSearchChips({ chips = [], onClear, resultCount, noun = 'risultati' }) {
  if (!chips.length) return null;
  return (
    <div
      className="mb-6 flex flex-wrap items-center gap-3 rounded-2xl border border-border bg-muted/40 px-4 py-3"
      data-testid="active-search-chips"
    >
      <span className="flex items-center gap-1.5 text-sm font-semibold text-foreground">
        <SlidersHorizontal className="h-4 w-4 text-primary" />
        Ricerca
      </span>
      <div className="flex flex-wrap items-center gap-2">
        {chips.map((c, i) => {
          const Icon = c.icon;
          return (
            <Badge key={i} variant="secondary" className="gap-1 rounded-full px-3 py-1 font-normal">
              {Icon && <Icon className="h-3.5 w-3.5 text-primary" />}
              {c.text}
            </Badge>
          );
        })}
      </div>
      {typeof resultCount === 'number' && (
        <span className="text-sm text-muted-foreground" data-testid="active-search-count">
          · <strong className="text-foreground">{resultCount}</strong> {noun}
        </span>
      )}
      <Button
        variant="ghost"
        size="sm"
        onClick={onClear}
        data-testid="active-search-clear"
        className="ml-auto h-8 rounded-full text-muted-foreground hover:text-foreground"
      >
        <X className="mr-1 h-3.5 w-3.5" /> Rimuovi filtri
      </Button>
    </div>
  );
}

// Normalizzazione condivisa per il match testuale (case/accent-insensitive).
export const normText = (s) =>
  (s == null ? '' : String(s)).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

export default ActiveSearchChips;
